import React from 'react';
import { allowedDomains, getValidDomain } from '../config/domains';

// Dynamically import all logo images from the domains directory
const logoContext = require.context('../domains', true, /logo\.png$/);
const defaultLogo = require('../shared/assets/img/logo.png');

const Header = ({ data }) => {
  // Get the domain name from data or default to localhost
  const domainName = getValidDomain(data.domainName || 'localhost');
  
  // Try to find the matching logo, fallback to default if not found
  const logoImage = allowedDomains.includes(domainName)
    ? logoContext(`./${domainName}/assets/img/logo.png`) || defaultLogo
    : defaultLogo;

  // Get nav buttons from data.json (default to empty array if not present)
  const topNavButtons = Array.isArray(data.topNavButtons) ? data.topNavButtons : [];

  return (
    <>
      <nav id="mainNav" className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <a className="navbar-brand page-scroll" href="#page-top">
              <img 
                src={logoImage} 
                alt={data.brandname} 
                style={{ maxHeight: '60px', color: '#FFF' }}
                onError={(e) => {
                  console.error('Failed to load image:', e.target.src);
                  e.target.src = defaultLogo;
                }}
              />
            </a>
          </div>

          <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul className="nav navbar-nav navbar-right">
              {topNavButtons.filter(btn => btn.enabled).map((btn, idx) => (
                <li key={idx}>
                  <a
                    className={`page-scroll ${btn.className || ''}`.trim()}
                    href={btn.href || '#'}
                  >
                    {btn.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
